<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="ch00_fm05_con"><a id="page_vii"></a>Contents</h2>
<p class="toc"><a class="nounder" href="#/xhtml/ch00_fm06_list#ch00_fm06_list"><em>List of Illustrations</em></a></p>
<p class="toc"><a class="nounder" href="#/xhtml/ch00_fm07_intro#ch00_fm07_intro">Introduction: Why Write the History of Ordinary People?</a></p>
<p class="toc1"><a class="nounder" href="#/xhtml/ch00_fm08_part01#ch00_fm08_part01"><span class="small">PART I</span>. The People Out of Doors</a></p>
<p class="toc2"><a class="nounder" href="#/xhtml/ch01#ch01">1. The Mechanics of the Revolution: “By Hammer and Hand All Arts Do Stand”</a></p>
<p class="toc2"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample">2. “Persons of Consequence”: The Women of Boston and the Making of the American Revolution, 1765–1776</span></p>
<p class="toc2"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample">3. Tar and Feathers and the Ghost of Oliver Cromwell: English Plebeian Culture and American Radicalism</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch03_part02#ch03_part02" title="Link target outside of Sample"><span class="small">PART II</span>. Accommodations</span></p>
<p class="toc2"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">4. Conservatives, the Constitution, and the “Genius of the People”</span></p>
<p class="toc2"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample">5. How Radical Was the American Revolution?</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch05_part03#ch05_part03" title="Link target outside of Sample"><span class="small">PART III</span>. Memory: Lost and Found</span></p>
<p class="toc2"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample">6. The Celebration and Damnation of Thomas Paine</span></p>
<p class="toc2"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample">7. The Freedom Trail: Walking the Revolution in Boston</span></p>
<p class="toc2"><a id="page_viii"></a><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample">8. Liberty Tree: Made in America, Lost in America</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch09_index#ch09_index" title="Link target outside of Sample"><em>Index</em></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch10_about#ch10_about" title="Link target outside of Sample"><em>About the Author</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm05_con.vue?648dfc33